import { render, staticRenderFns } from "./CollectionCard.vue?vue&type=template&id=542af135&scoped=true"
import script from "./CollectionCard.vue?vue&type=script&lang=js"
export * from "./CollectionCard.vue?vue&type=script&lang=js"
import style0 from "./CollectionCard.vue?vue&type=style&index=0&id=542af135&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542af135",
  null
  
)

export default component.exports